import * as Yup from 'yup';
import {
  ADD_WEBHOOK,
  CONTINUE,
  CUSTOM,
  DEFAULT,
  DONE,
  EDIT,
  EXPONENTIAL,
  FIXED,
  NEXT,
  SAVE,
  TEST,
  WEBHOOK,
} from './constants';
import cloneDeep from 'lodash/cloneDeep';
import flattenDeep from 'lodash/flattenDeep';
import difference from 'lodash/difference';

export const validationSchema = Yup.object({
  channelValue: Yup.string()
    .test('url-validation', 'Please enter a valid URL starting with http:// or https:// and with a valid domain', function(value) {
      // Skip validation if value is empty (the .required() will handle this separately)
      if (!value) return true;
            const urlPattern = /^https?:\/\/(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|localhost)(?::\d+)?(?:\/[-a-zA-Z0-9%_.~#+]*)*(?:\?[^\s"]*)?(?:#[-a-zA-Z0-9%_&=]*)?$/i;
      const fallbackPattern = /^https?:\/\/[-a-zA-Z0-9@:%._+~#=]{1,256}(:\d+)?(\/[-a-zA-Z0-9()@:%_+.~#?&=]*)?$/;
      
      return urlPattern.test(value) || fallbackPattern.test(value);
    })
    .required('This field cannot be left blank')
    .trim(),
    
  cfApiVersion: Yup.string()
    .required('This field cannot be left blank')
    .trim(),
});

export const formatNotificationList = (list,isSubscription=false) => {
  const formattedList = [];
  list.forEach(item => {
    let newItem = item.replaceAll('_', ' ');
    newItem = newItem.toLowerCase();
    formattedList.push(newItem);
  });
  formattedList.sort();
  if(isSubscription){
    return formattedList.filter(sortedList=>sortedList.includes('subscription'))

  }else{
    return formattedList.filter(sortedList=>!sortedList.includes('subscription'))
  }
};

export const prepareFormData = (
  endpointDetails,
  policyListData,
  merchantId,
  checkedItems,
) => {
  const { channelValue, cfApiVersion } = endpointDetails;
  const channelDetails: any = [];
  policyListData.forEach((policyData, index) => {
    checkedItems[index].forEach(item => {
      let { intervalValue, ...rest } = policyData;

      if (
        policyData.retryType === FIXED ||
        policyData.retryType === EXPONENTIAL
      ) {
        rest = { ...rest, retryInterval: [intervalValue] };
      }
      const notificationType = item.toUpperCase().replace(/\s/g, '_');
      const channelDetailsObj = {
        channelValue: channelValue.trim(),
        notificationType,
        notificationChannel: WEBHOOK,
        cfApiVersion,
        isActive: true,
        createdBy: parseInt(merchantId, 10),
        updatedBy: parseInt(merchantId, 10),
        retryPolicy: rest,
      };
      channelDetails.push(channelDetailsObj);
    });
  });
  return channelDetails;
};

export const removedEventsData = (
  checkedItems,
  actionsMode,
  testWebhookData,
) => {
  if (actionsMode !== EDIT) return [];
  let selectedEvents = cloneDeep(checkedItems);
  let initialEvents = cloneDeep(testWebhookData);
  return difference(
    flattenDeep(initialEvents.checkedItems),
    flattenDeep(selectedEvents),
  );
};

export const prepareRemovedEventsData = (
  removedEvents,
  testWebhookData,
  _policyListData,
  actionsMode,
) => {
  if (actionsMode !== EDIT) return [];
  const updateChannel = [];
  const { channelValue, cfApiVersion } = testWebhookData.channelDetails;
  removedEvents.forEach(event => {
    const removedEventObj = {
      notificationType: event.toUpperCase().replace(/\s/g, '_'),
      notificationChannel: WEBHOOK,
      channelValue,
      isActive: false,
      cfApiVersion,
    };
    updateChannel.push(removedEventObj);
  });

  return updateChannel;
};

export const submitButtonDisplay = (actionsMode, step) => {
  if (!actionsMode || actionsMode === EDIT) {
    return step === 2 ? SAVE : CONTINUE;
  }
  return actionsMode === TEST ? DONE : SAVE;
};

export const findEventsLength = obj => {
  let eventsArr = obj.merchantNotificationTypeDetailsResponse;
  eventsArr = eventsArr.filter(
    item => item.IsActive && !item.NotificationType.includes('PAYMENT_FORM') &&
    item.NotificationType.includes('SUBSCRIPTION'),
  );
  return eventsArr.length;
};

export const findArrowDown = (obj, chevronIcon) => {
  const isArrowDown =
    !chevronIcon ||
    !chevronIcon[obj.channelValue] ||
    chevronIcon[obj.channelValue] === 'down';
  return isArrowDown;
};

export const getComponentIcon = (activeIndex, currentIndex, actionsMode) => {
  if (activeIndex === currentIndex) {
    return 'BLUE_DOT';
  } else if (currentIndex < activeIndex || actionsMode === EDIT) {
    return 'GREEN_TICK_DOT';
  } else {
    return 'GREY_DOT';
  }
};

export const getVerticalColor = (activeIndex, currentIndex, actionsMode) => {
  if (currentIndex < activeIndex || actionsMode === EDIT) {
    return 'active';
  } else {
    return '';
  }
};
export const getRetryInterval = policyData => {
  const intervalList = [];
  intervalList.push(parseInt(policyData.intervalValue, 10));
  for (let i = 1; i < policyData.maxRetryAttempts; i++) {
    if (policyData.retryType === FIXED) {
      let data = parseInt(policyData.intervalValue, 10) + intervalList[i - 1];
      intervalList.push(data);
    } else {
      let val =
        parseInt(policyData.intervalValue, 10) +
        Math.pow(policyData.multiplier, i);
      intervalList.push(val);
    }
  }
  return intervalList;
};

export const getRetryMessage = PolicyData => {
  const {
    retryType,
    maxRetryAttempts,
    retryInterval,
    timeUnit,
    multiplier,
  } = PolicyData;
  if (retryType === DEFAULT) {
    return `There will be total of ${maxRetryAttempts} retries and each retry will happen after ${retryInterval.join(
      ',',
    )} ${timeUnit.toLowerCase()}`;
  } else if (retryType === FIXED) {
    return `There will be total of ${maxRetryAttempts} retries and each retry will happen after ${retryInterval.join(
      ',',
    )} ${timeUnit.toLowerCase()}`;
  } else if (retryType === CUSTOM) {
    return `There will be total of ${maxRetryAttempts} retries and each retry will happen after ${retryInterval.join(
      ',',
    )} ${timeUnit.toLowerCase()}`;
  } else {
    return `There will be total of ${maxRetryAttempts} retries and each retry will happen after the following intervals ${retryInterval.join(
      ',',
    )} ${timeUnit.toLowerCase()}`;
  }
};

export const getDisableOption = (item, checkedItems, index) => {
  const checkedOptions: any[] = cloneDeep(checkedItems);
  checkedOptions.splice(index, 1);
  const flattenOptions = flattenDeep(checkedOptions);
  return flattenOptions.includes(item);
};

export const getBarPercentage = (retryType, interval) => {
  let updatedInterval = [...interval];
  if (retryType === CUSTOM) {
    for (let i = 1; i < updatedInterval.length; i++) {
      updatedInterval[i] += updatedInterval[i - 1];
    }
  }
  let percentageArray = [];
  let maxDifference =
    100 / (updatedInterval[interval.length - 1] - updatedInterval[0]);

  for (let i = 0; i < updatedInterval.length; i++) {
    let val = (updatedInterval[i] - updatedInterval[0]) * maxDifference;
    if (i !== updatedInterval.length) {
      val -= 1;
    }
    percentageArray.push(val);
  }

  return percentageArray;
};


export const getUpdatedResponse=(response)=>{
  if(!response?.length){
    return []
  }
  const elementsToMove = response?.filter(item => item.channelValue === 'NOTIFY_URL');
    
  const otherElements = response?.filter(item => item.channelValue !== 'NOTIFY_URL');
  
  return elementsToMove.concat(otherElements);

}


export const prepareSubRemovedEventsData = (removedEvents, testWebhookData) => {
  const updateChannel = [];
  const { channelValue, cfApiVersion } = testWebhookData;
  removedEvents.forEach(event => {
    const removedEventObj = {
      notificationType: event.toUpperCase().replace(/\s/g, '_'),
      notificationChannel: WEBHOOK,
      channelValue,
      isActive: false,
      cfApiVersion,
    };
    updateChannel.push(removedEventObj);
  });
  return updateChannel;
};

export const prepareSubFormData = (values, merchantId, checkedItems) => {
  const { channelValue, cfApiVersion } = values;
  const channelDetails = [];
  checkedItems.forEach(item => {
    const notificationType = item.toUpperCase().replace(/\s/g, '_');
    const channelDetailsObj = {
      channelValue: channelValue.trim(),
      notificationType,
      notificationChannel: WEBHOOK,
      cfApiVersion,
      isActive: true,
      createdBy: parseInt(merchantId, 10),
      updatedBy: parseInt(merchantId, 10),
    };
    channelDetails.push(channelDetailsObj);
  });
  return channelDetails;
};

export const removedSubEventsData = (values, actionsMode, testWebhookData) => {
  if (actionsMode !== EDIT) return [];
  let selectedEvents = Object.assign({}, values);
  delete selectedEvents.cfApiVersion;
  delete selectedEvents.channelValue;
  Object.keys(selectedEvents).forEach(item => {
    if (!selectedEvents[item]) delete selectedEvents[item];
  });
  selectedEvents = Object.keys(selectedEvents);
  let initialEvents = Object.assign({}, testWebhookData);
  delete initialEvents.channelValue;
  delete initialEvents.cfApiVersion;
  initialEvents = Object.keys(initialEvents);
  return initialEvents.filter(event => !selectedEvents.includes(event));
};

